import React, { useState } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import Sidebar, { drawerWidth } from "./components/sidebar";
import ShellAppbar from "./components/appbar";
import { LoadingPage } from "../core";

const Shell = (): JSX.Element => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const session = localStorage.getItem("session");
  const accessToken = session && JSON.parse(session).accessToken;
  if (accessToken) {
    // polling.startPolling(accessToken); // ! you can uncomment this line to start polling
  }

  return (
    <>
      <ShellAppbar onMenuClick={handleDrawerToggle} />
      <Sidebar mobileOpen={mobileOpen} onMobileClose={handleDrawerToggle} />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          p: 2,
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` }
        }} 
        className={"bg-secondary"}
      >
        <Toolbar />
        <div
          style={{
            minHeight: "90vh",
            minWidth: "300px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Suspense fallback={<LoadingPage />}>
            <Outlet />
          </Suspense>
        </div>
      </Box>
    </>
  );
};

export default Shell;
